module.exports = __webpack_public_path__ + "img/phone7.445e2aa6.png";